import Moment from 'moment'
import _ from 'lodash'
import {
  FETCH_CATS
} from './types'
import axios from '../services/axios'
import storage from '../services/storage'

export function get() {
  return (dispatch)=>{
    storage.get('page').
    then((page)=>{
      return axios.get(`/categorias/${page}`)
    }).then((response)=> {
      dispatch({
        type: FETCH_CATS,
        payload: response.data.data
      })
    }).catch((error) => {
      console.log(error)
    })
  }
}

export function add(category, exclude) {
  return function(dispatch) {
    storage.get('page').
    then((page)=>{
      return axios.post(`/categorias/${page}`, {
        text: category,
        exclude: exclude
      })
    }).then((response)=> {
      dispatch({
        type: FETCH_CATS,
        payload: response.data.data
      })
    }).catch((error) => {
      console.log(error)
    })
  }
}

export function edit(id, category, exclude) {
  return function(dispatch) {
    storage.get('page').
    then((page)=>{
      return axios.put(`/categorias/${page}/${id}`, {
        text: category,
        exclude: exclude
      }).then((response)=> {
        return axios.get(`/categorias/${page}`)
      })
    }).then((response)=> {
      dispatch({
        type: FETCH_CATS,
        payload: response.data.data
      })
    }).catch((error) => {
      console.log(error)
    })
  }
}

export function remove(id) {
  return function(dispatch) {
    storage.get('page').
    then((page)=>{
      return axios.delete(`/categorias/${page}/${id}`)
      .then((response)=> {
        return axios.get(`/categorias/${page}`)
      })
    }).then((response)=> {
      dispatch({
        type: FETCH_CATS,
        payload: response.data.data
      })
    }).catch((error) => {
      console.log(error)
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/categories.js